jQuery(document).ready(function($) {
    var header = $('.header-site');
    var lastScrollTop = 0;
    var headerHeight = header.outerHeight();

    $(window).scroll(function() {
        var scrollTop = $(this).scrollTop();
        if (scrollTop > lastScrollTop) {
            if (scrollTop > headerHeight) {
                header.addClass('scrolled');
            }
        } else {
            if (scrollTop === 0) {
                header.removeClass('scrolled');
            }
        }
        lastScrollTop = scrollTop;
    });
});


/**
* custom banner full width page careers
**/

let divBannerContainer=document.getElementsByClassName("cover-effect-scroll-img")[0];

if (typeof divBannerContainer !== 'undefined' && divBannerContainer !== null) {
    let alturaScroll = divBannerContainer.clientHeight + 18;
    divBannerContainer.scrollTo(0, alturaScroll);
}


